import { render, staticRenderFns } from "./baseVideo.vue?vue&type=template&id=8502d234&scoped=true"
import script from "./baseVideo.vue?vue&type=script&lang=js"
export * from "./baseVideo.vue?vue&type=script&lang=js"
import style0 from "./baseVideo.vue?vue&type=style&index=0&id=8502d234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502d234",
  null
  
)

export default component.exports